import { prefixObjectValues } from '../../utils';
const form = {
  NpiNumberInput: 'NPINumberInput',
  providerCatSelect: 'providerCatSelect',
  providerTypeSelect: 'providerTypeSelect',
  languagesMultiSelect: 'lang-multiSelect',
  cancelBtn: 'cancelBtn',
  updateBtn: 'updateBtn',
  submitBtn: 'submitBtn',
};

export default prefixObjectValues(form, 'profile-professional-info-form');
